import React from 'react'

const FAQ: React.FC = () => {
  return (
    <section id="section_faq" className="section_home-faq">
      <div className="padding-global">
        <div className="container-large">
          <div className="py-12 md:py-16">
            <div className="margin-bottom margin-xxlarge">
              <div className="text-align-center">
                <div className="max-width-large align-center">
                  <div className="margin-bottom margin-small">
                    <h2>Frequently Asked <span className="text-highlight">Questions</span></h2>
                  </div>
                  <p className="text-size-medium">Everything you need to know about our research-driven approach</p>
                </div>
              </div>
            </div>

            <div className="faq9_component">
              <div className="faq9_list">
                <div className="faq_item">
                  <div className="faq9_question">
                    <h3 className="heading-style-h4">How do you ensure property appreciation?</h3>
                  </div>
                  <p className="text-color-grey">At Singh's Best Buy, appreciation isn't luck — it's research, timing, and trust. We handpick only a few projects after deep analysis of location growth, developer credibility, and structural quality. Our in-house civil engineer verifies every project technically, while our network ensures exclusive early-phase access — where real appreciation begins. Because we're not here to sell you a random property — we help you own the right one, at the right stage, so your capital grows naturally over time. That's how Singh's Best Buy turns every home into a long-term asset.</p>
                </div>

                <div className="faq_item">
                  <div className="faq9_question">
                    <h3 className="heading-style-h4">What makes your approach different from brokers?</h3>
                  </div>
                  <p className="text-color-grey">We are not brokers — we are curators of opportunity. We connect you directly with master brokers to unlock exclusive pricing, early access, and strategic investment options that aren't available publicly.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ
